import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-742a409f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "oxd-brand-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["oxd-brand", _ctx.classes]),
    href: _ctx.url
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        alt: "client brand logo",
        src: _ctx.logoSrc
      }, null, 8, _hoisted_3)
    ], 512), [
      [_vShow, _ctx.toggle]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["oxd-brand-banner", _ctx.classes])
    }, [
      _createElementVNode("img", {
        alt: "client brand banner",
        src: _ctx.bannerSrc
      }, null, 8, _hoisted_4)
    ], 2)
  ], 10, _hoisted_1))
}